import { useCallback, useEffect, useState } from "react";
import { getListFileExport } from "../../services/exportService"; 

const useListFileExport = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getListFileExport();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useListFileExport;
